import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Configuration, PmsApi, PaymentsApi, ResidentSearchParamsDTO, ResidentEditParamsDTO, CreateOneTimePaymentDto, BankCardsApi, ResidentSearchResponseV2Dto } from "@inosio/payments-sdk";
import { selectCurrentUser } from "../../../shared/sagas/auth/authSlice";
import { getResidentsData, setResidentsData, getResidentsDataFailed } from "./pmResidentsSlice";
import { setEditResidentData, setEditResidentError, getEditResidentData, getResidentPaymentFees } from "./pmResidentsSlice";
import { getCreateAdhocOTP, getResidentBalanceDetails, setCreateAdhocOTPResponse, setCreateAdhocOTPError } from "./pmResidentsSlice";
import { setResidentPaymentFeesResponse, setResidentPaymentFeesError, setResidentBalanceDetailsResponse } from "./pmResidentsSlice";
import { setResidentBalanceDetailsError, getResidentBankCardType, setResidentBankCardTypeResponse, setResidentBankCardTypeError } from "./pmResidentsSlice";
import {IpaUserExtended} from "../../../shared/sagas/auth/authSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestEditResidentData(access_token: string, pmUUID: string, residentEditParamsDTO: ResidentEditParamsDTO) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);
  return ipaPmAPI.editAcceptedPaymentMethods(pmUUID, residentEditParamsDTO);
}

export function requestGetResidentsData(access_token: string, pmUUID: string, residentSearchParamsDTO: ResidentSearchParamsDTO) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);
  return ipaPmAPI.searchResidentsByPM(pmUUID, residentSearchParamsDTO);
}

export function requestCreateAdhocOTP(access_token: string, pmUuID: string, createOneTimePaymemtDto: CreateOneTimePaymentDto) {
  apiConfig.accessToken = access_token;
  const pmtsAPI = new PaymentsApi(apiConfig);

  return pmtsAPI.createOneTimePayment(createOneTimePaymemtDto);
}

export function requestGetResidentPaymentFees(access_token: string, pmUuID: string, residentUuid: string, paymentAmount: number, propertyPaymentTypeId: number) {
  apiConfig.accessToken = access_token;
  const pmtsAPI = new PaymentsApi(apiConfig);

  return pmtsAPI.getPaymentFees(residentUuid, paymentAmount, propertyPaymentTypeId);
}

export function requestGetResidentBalanceDetails(access_token: string, pmUuID: string, residentUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.getResidentBalanceDetails(pmUuID, residentUuid);
}

export function requestGetResidentBankCardType(access_token: string, cardPrefix: string) {
  apiConfig.accessToken = access_token;
  const ipaBankCardsAPI = new BankCardsApi(apiConfig);

  return ipaBankCardsAPI.getBankCardTypeByBIN(cardPrefix);
}

export function* handleGetEditResident(action: { type: typeof getEditResidentData; payload: ResidentEditParamsDTO }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestEditResidentData, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);
    const { data } = response;
    yield put(setEditResidentData(data));
  } catch (error: any) {
    console.error(error?.response?.data?.message);
    yield put(setEditResidentError({ message: error?.response?.data?.message }));
  }
}

export function* handleGetResidents(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ResidentSearchResponseV2Dto> = yield call(requestGetResidentsData, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);
    const { data } = response;
    yield put(setResidentsData(data));
  } catch (error: any) {
    console.error(error?.response?.data?.message);
    yield put(getResidentsDataFailed({
      message: error?.response?.data?.message,
      statusCode: error?.response?.data?.statusCode
    }));
  }
}

export function* handleCreateAdhocOTP(action: { type: typeof getCreateAdhocOTP; payload: CreateOneTimePaymentDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestCreateAdhocOTP, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);

    const { data } = response;
    yield put(setCreateAdhocOTPResponse(data));
  } catch (error: any) {
    yield put(setCreateAdhocOTPError(error?.response?.data?.message));
  }
}

export function* handleGetResidentPaymentFees(action: { type: typeof getResidentPaymentFees; payload: { residentUuid: string; paymentAmount: number; propertyPaymentTypeId: number } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestGetResidentPaymentFees, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.residentUuid, action.payload.paymentAmount, action.payload.propertyPaymentTypeId);

    const { data } = response;
    yield put(setResidentPaymentFeesResponse(data));
  } catch (error: any) {
    yield put(setResidentPaymentFeesError(error?.response?.data?.message));
  }
}

export function* handleGetResidentBalanceDetails(action: { type: typeof getResidentBalanceDetails; payload: { residentUuid: string } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestGetResidentBalanceDetails, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.residentUuid);

    const { data } = response;
    yield put(setResidentBalanceDetailsResponse(data));
  } catch (error: any) {
    yield put(setResidentBalanceDetailsError(error?.response?.data?.message));
  }
}

export function* handleGetResidentBankCardType(action: { type: typeof getResidentBankCardType; payload: { cardPrefix: string } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestGetResidentBankCardType, currentUser?.accessToken, action.payload.cardPrefix);

    const { data } = response;
    yield put(setResidentBankCardTypeResponse(data));
  } catch (error: any) {
    yield put(setResidentBankCardTypeError(error?.response?.data?.message));
  }
}

export function* pmResidentsSaga() {
  yield takeLatest(getResidentsData.type, handleGetResidents);
  // yield takeLatest(sendEmail.type, handleSendEmail);
  yield takeLatest(getEditResidentData.type, handleGetEditResident);
  yield takeLatest(getResidentPaymentFees.type, handleGetResidentPaymentFees);
  yield takeLatest(getCreateAdhocOTP.type, handleCreateAdhocOTP);
  yield takeLatest(getResidentBalanceDetails.type, handleGetResidentBalanceDetails);
  yield takeLatest(getResidentBankCardType.type, handleGetResidentBankCardType);
}
